import ACTIONS from "./actions";

export const initialState = {
  status: {
    isLoading: true,
    isError: false,
    data: [],
  },
};

function logDownloadReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.FETCH_LOG_DOWNLOAD_INIT: {
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    }

    case ACTIONS.FETCH_LOG_DOWNLOAD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    }

    case ACTIONS.FETCH_LOG_DOWNLOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    }

    default:
      return state;
  }
}

export default logDownloadReducer;
